var map = {
	"./CircularStd-Bold.woff": 68976,
	"./CircularStd-BoldItalic.woff": 61552,
	"./CircularStd-Book.woff": 80518,
	"./CircularStd-BookItalic.woff": 87922,
	"./CircularStd-Medium.woff": 84344,
	"./CircularStd-MediumItalic.woff": 59368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7220;